import { Box, Dialog, Portal } from '@chakra-ui/react'
import type { ReactNode } from 'react'

interface SideSheetDialogProps {
  isOpen: boolean
  onClose: () => void
  title: ReactNode
  width?: string
  body: ReactNode
  footer?: ReactNode
}

export const SideSheetDialog = ({
  isOpen,
  onClose,
  title,
  width = '480px',
  body,
  footer,
}: SideSheetDialogProps) => {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(details) => !details.open && onClose()}
    >
      <Portal>
        <Dialog.Backdrop
          backdropFilter="blur(4px)"
          position="fixed"
          inset={0}
        />
        <Dialog.Positioner
          position="fixed"
          inset={0}
          display="flex"
          alignItems="stretch"
          justifyContent="flex-end"
          css={{
            alignItems: 'stretch !important',
            justifyContent: 'flex-end !important',
          }}
        >
          <Dialog.Content
            w={width}
            maxW="95vw"
            h="100vh"
            bg="bg.panel"
            borderRadius="none"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            position="fixed"
            top={0}
            right={0}
            m={0}
            css={{
              left: 'auto !important',
              right: '0 !important',
              transform: 'none !important',
              margin: '0 !important',
            }}
          >
            <Dialog.Header
              p={5}
              borderBottomWidth={1}
              borderColor="border.default"
            >
              <Dialog.Title fontSize="lg" fontWeight="semibold">
                {title}
              </Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body p={5} flex={1} overflowY="auto">
              {body}
            </Dialog.Body>
            {footer ? (
              <Box p={5} pt={4} borderTopWidth={1} borderColor="border.default">
                {footer}
              </Box>
            ) : null}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
